// Stryker disable all

import { sendExperienceAnalytics } from '@jira/issue__issue-view-analytics/src/sendExperienceAnalytics.tsx';
import type { Action } from '@jira/platform__jira-experience-tracker/src/common/constants.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { isFetchError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isGiraUrl } from './isGiraUrl.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export default async function issueViewAsJson<TResponse = any>(
	url: string,
	options: RequestInit | undefined = {},
	path: string,
): Promise<TResponse> {
	if (!fg('issue-view-enable-reliability-wrapper-utils')) {
		return fetchJson<TResponse>(url, options);
	}
	const defaultExperienceDescription = {
		experience: isGiraUrl(url) ? 'issueGira' : 'issueRest',
		analyticsSource: isGiraUrl(url) ? 'issueGira' : 'issueRest',
		application: null,
		edition: null,
	};
	try {
		const response = await fetchJson<TResponse>(url, {
			...options,
		});
		return response;
	} catch (error) {
		if (isFetchError(error)) {
			const additionalAttributes = {
				statusCode: error.statusCode || 0,
				errorMessage: error.message || 'unknown',
				traceId: error.traceId || 'unknown',
				path,
			};
			const statusCode = additionalAttributes.statusCode;
			let action: Action = 'taskFail';
			if (statusCode && statusCode >= 400 && statusCode < 500) {
				action = 'taskAbort';
			}

			sendExperienceAnalytics({
				...defaultExperienceDescription,
				action,
				additionalAttributes,
			});
		}
		throw error;
	}
}
